// @ts-check
// Settings → Check-Ins → the categories the classic review's cards use, and
// which category each performance row starts in. A coach's own choice is kept
// in coaches.settings.checkinCategories.analyticsOverrides, and only when it
// differs from the start below. Moved out of app.js on 2026-10-23. "Overall
// Compliance" (the Effort score) left the list the same day, with the row: the
// Effort score is off the check-in. An old saved choice for it is just ignored.

export const CI_PREDEFINED_CATS = ['Body', 'Compliance', 'Nutrition', 'Mindset'];
export const CI_ANALYTICS_ROWS = ['Workouts Completed', 'Cardio Completed', 'Habits Completed', 'Avg Daily Steps', 'Weight', 'Avg Sleep', 'Nutrition Targets'];
/** @type {Record<string, string>} */
export const CI_ANALYTICS_DEFAULTS = { 'Workouts Completed': 'Compliance', 'Cardio Completed': 'Compliance', 'Habits Completed': 'Compliance', 'Avg Daily Steps': 'Compliance', 'Weight': 'Body', 'Avg Sleep': 'Body', 'Nutrition Targets': 'Nutrition' };
